// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__39ZZX","content":"styles_content__b5oo0","subtitle":"styles_subtitle__2Ynfh"};